var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
        'loading-overlay',
        {
            'loading-overlay--is-absolute': _vm.isAbsolute
        }
    ]},[_c('Loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }